import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import ROUTE_NAMES from 'setup/Routing/routeNames';

// Forwards the super admin Reports page's old address to the new one, keeping
// the tab, kind or segment and the query string:
// /monthly_reports/usage/weekly -> /scheduled_reports/usage/weekly
export default function LegacyReportsRedirect() {
  const { pathname, search } = useLocation();
  const rest = pathname.slice(ROUTE_NAMES.superadmin.legacyReports.length);

  return (
    <Navigate
      to={`${ROUTE_NAMES.superadmin.reports}${rest}${search}`}
      replace
    />
  );
}
